export default __webpack_public_path__ + "static/media/pay.276ad639.svg";